import { render, staticRenderFns } from "./PointListForm.vue?vue&type=template&id=18fbfb84&scoped=true&"
import script from "./PointListForm.vue?vue&type=script&lang=js&"
export * from "./PointListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbfb84",
  null
  
)

export default component.exports